import React from 'react';
import styled from 'styled-components';
import { PlainIcon } from '../../../AlmeUtilities/Icons/PlainIcon';
import { colors } from 'syf-component-library/defaultTheme';
const Button = styled.button `
  border: none;
  background: none;
  color: ${props => colors.mediumGrey};
  visibility: ${props => props.disabled ? "hidden" : "visible"};
  padding: 0 5px;
  margin: 0;
`;
const NavigationButton = ({ onClick, disabled, icon, label, }) => {
    return (React.createElement(Button, { onClick: onClick, disabled: disabled, "aria-label": label },
        React.createElement(PlainIcon, { size: 20, icon: icon })));
};
export default NavigationButton;
